import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calculator, FileText, Wrench } from 'lucide-react';

const FloatingButtons = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  // Zeige Buttons nach kurzem Scroll
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    // Zeige immer nach 2 Sekunden
    setTimeout(() => setIsVisible(true), 2000);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const handleFinanzierung = () => {
    // Öffne Consors Finanz Online-Kredit Kreditrechner
    window.open(
      'https://www.consorsfinanz.de/karte-kredite/online-kredit#Kreditrechner',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handleWaermepumpe = () => {
    navigate('/waermepumpe');
  };

  const handleNovatusCare = () => {
    // Öffne Novatus Care Wartungsportal
    window.open(
      process.env.REACT_APP_CARE_URL || 'https://heatpump-care.emergent.host',
      '_blank',
      'noopener,noreferrer'
    );
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Desktop: Floating Buttons rechts unten - höher positioniert */}
      <div className="fixed right-6 bottom-24 z-50 hidden md:flex flex-col gap-3">
        {/* Novatus Care Button */}
        <button
          onClick={handleNovatusCare}
          className="group flex items-center gap-3 bg-gradient-to-r from-[#2D4A3E] to-[#1A3A2E] hover:from-[#3A5A4E] hover:to-[#2D4A3E] text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
          aria-label="Novatus Care Wartungsportal"
          title="Service & Wartung für Ihre Wärmepumpe"
        >
          <Wrench className="w-6 h-6" />
          <span className="font-semibold text-base whitespace-nowrap">
            Novatus Care Wartungsportal
          </span>
        </button>

        {/* Finanzierung Button */}
        <button
          onClick={handleFinanzierung}
          className="group flex items-center gap-3 bg-gradient-to-r from-[#1A3A2E] to-[#2D4A3E] hover:from-[#2D4A3E] hover:to-[#3A5A4E] text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
          aria-label="Finanzierung berechnen"
        >
          <Calculator className="w-6 h-6" />
          <span className="font-semibold text-base whitespace-nowrap">
            Finanzierung berechnen
          </span>
        </button>

        {/* Wärmepumpe anfragen Button */}
        <button
          onClick={handleWaermepumpe}
          className="group flex items-center gap-3 bg-[#E8F5E0] hover:bg-[#d4e8ca] text-[#1A3A2E] px-6 py-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
          aria-label="Wärmepumpe anfragen"
        >
          <FileText className="w-6 h-6" />
          <span className="font-semibold text-base whitespace-nowrap">
            Wärmepumpe anfragen
          </span>
        </button>

        {/* Hinweis-Badge für Finanzierung */}
        <div className="absolute -top-2 -left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full animate-pulse">
          Neu!
        </div>
      </div>

      {/* Mobile: Bottom Bar mit allen drei Buttons */}
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t-2 border-[#1A3A2E]/10 shadow-2xl">
        <div className="grid grid-cols-3 gap-0">
          {/* Novatus Care Button */}
          <button
            onClick={handleNovatusCare}
            className="flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-[#2D4A3E] to-[#1A3A2E] text-white py-4 px-2 active:bg-[#3A5A4E] transition-colors"
            aria-label="Novatus Care Wartungsportal"
          >
            <Wrench className="w-5 h-5" />
            <span className="font-semibold text-[10px] text-center leading-tight">
              Novatus<br/>Care
            </span>
          </button>

          {/* Finanzierung Button */}
          <button
            onClick={handleFinanzierung}
            className="relative flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-[#1A3A2E] to-[#2D4A3E] text-white py-4 px-2 active:bg-[#3A5A4E] transition-colors"
            aria-label="Finanzierung berechnen"
          >
            {/* Neu Badge */}
            <div className="absolute top-1 right-1 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">
              Neu
            </div>
            <Calculator className="w-5 h-5" />
            <span className="font-semibold text-[10px] text-center leading-tight">
              Finanzierung<br/>berechnen
            </span>
          </button>

          {/* Wärmepumpe anfragen Button */}
          <button
            onClick={handleWaermepumpe}
            className="flex flex-col items-center justify-center gap-2 bg-[#E8F5E0] text-[#1A3A2E] py-4 px-2 active:bg-[#d4e8ca] transition-colors"
            aria-label="Wärmepumpe anfragen"
          >
            <FileText className="w-5 h-5" />
            <span className="font-semibold text-[10px] text-center leading-tight">
              Wärmepumpe<br/>anfragen
            </span>
          </button>
        </div>
      </div>

      {/* Spacer für Mobile, damit Inhalt nicht von Bottom Bar verdeckt wird */}
      <div className="h-24 md:hidden" />
    </>
  );
};

export default FloatingButtons;
